import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
};

const breadCrumbSlice = createSlice({
    name: "breadCrumbSlice",
    initialState,
    reducers: {
        resetCrumb: (state) => {
            state.data = []
        },
        addCrumb: (state, action) => {
            state.data = action.payload;
            state.enabled = true
        }
    }
});

export const breadCrumbReducer = breadCrumbSlice.reducer;
export const { resetCrumb, addCrumb } = breadCrumbSlice.actions;
export const breadCrumbSelector = (store) => store.breadCrumb
